import React from 'react'
import { getFirstParagraphText, getFirstTitleFromHtml, hasHtmlContent } from '../../../helpers/utilities';
import { ModifyEditScreenSkeleton } from '../Skeletons/BatchScreenSkeletons';
import Icon from '../Icon';
import Toggle from '../Toggle/Toggle';


const MainEdit = ({ 
    creation, 
    onClose, 
    handleSubmit, 
    loading, 
    handleFileChange, 
    previewImage, 
    error, 
    setOpenEditInput, 
    capitalizeFirstLetter, 
    handleDeleteMedia,
    isPhysical = false,
    sizeEntries = [],
    isSizingAndQuantitiesEnabled = false,
    selectedShippingMethodId = null,
    selectedShippingMethodName = null,
    onOpenShippingMethodSelector = () => {},
    allowDownload = false,
    setAllowDownload = () => {}
}) => {


    return (creation ? <div className="modify-container" >
        <div className="d-flex aic jcc modify-header mb-8">
            <Icon alias={"chevron-left"} width={24} color="#0A0F1E" className={"p-absolute"} style={{ left: 16 }} onClick={onClose} />
            <span className="fg-black fw-bold fs-sm2">Edit creation</span>
            {/* Single Save control — desktop had a duplicate button (HYK-986 layout pass) that
                called onClose() synchronously, closing the form before updateCreation finished. */}
            <button
                className="btn btn-sm red-btn rounded-xl fs-xxs p-fixed px-16"
                style={{ right: '16px' }}
                disabled={loading}
                onClick={handleSubmit}
            >
                {loading ? "Saving..." : "Save"}
            </button>
        </div>
        <div className="mt-40 pt-40 w-full" onClick={(e) => e.stopPropagation()}>

            <div
                className={`thumbnail-creation p-relative px-16`}
                key={creation.creation_id}
            >
                {creation?.thumbnail_url ? (
                    <img
                        src={creation.thumbnail_url}
                        alt={creation.title || "Creation preview"}
                        className="img-thumbnail"
                    />
                ) : previewImage ?
                    <img
                        src={previewImage}
                        alt={creation.title || "Creation preview"}
                        className="img-thumbnail"
                    />
                    : (
                        <label className="add-creation__preview-upload d-flex f-column">
                            <input
                                type="file"
                                onChange={(e) => handleFileChange(e)}
                                accept="image/*"
                                hidden
                            />
                            <div className="add-creation__upload-button">

                                <div className="add-creation__upload-placeholder">
                                    <i className="fas fa-plus fs-md fw-medium fg-dark"></i>
                                    <span className=' fs-sm2 fg-dark fw-bold'>Add a thumbnail</span>
                                    <span className=' fs-xxs fg-grey7'>PNG, JPG or JPEG</span>

                                </div>
                            </div>

                            <div className='d-flex f-row jcsb aie px-48 mb-8 w-100'>
                                <div className='d-flex f-column aic'>
                                    <div className='rect rec1'></div>
                                    <p className='fs-tiny fw-bold fg-grey7 mt-8'>1080x1920</p>
                                </div>
                                <div className='d-flex f-column aic jce'>
                                    <div className='rect rec2 '></div>
                                    <p className='fs-tiny fw-bold fg-grey7 mt-8'>1080x1080</p>
                                </div>
                                <div className='d-flex f-column aic jce '>
                                    <div className='rect rec3'></div>
                                    <p className='fs-tiny fw-bold fg-grey7 mt-8'>1920x1080</p>
                                </div>
                            </div>
                        </label>
                    )}
                {/* <img
                            src={creation.thumbnail_url || creation.media_url}
                            alt={creation.title || "Creation preview"}
                            className="img-thumbnail"
                        /> */}
                {(creation?.thumbnail_url || previewImage) && <span className="trash" onClick={handleDeleteMedia}>
                    <Icon alias={'trash'} width={24} color='transparent' stroke='#C9100E' className='ml-auto' />
                </span>}
                {error?.thumbnail_url && <p className='fs-real fw-medium fg-xtred ta-center'>{error.thumbnail_url}</p>}
            </div>
            {/* <p className="fg-crea mt-16 mb-8 pb-16 modify-media" onClick={() => onEditMedia(true)}>Edit media and preview</p> */}
            <div className="modify-form px-16">
                <div className="d-flex aic">
                    <span className="modify-info">Format</span>
                    <p className="input-main" onClick={() => setOpenEditInput("format")}>{capitalizeFirstLetter(creation?.media?.media_format)}</p>
                    {/* <select
                            name="format"
                            value={creation?.media?.media_format}
                            onChange={handleChange}
                            className="input-main"
                        >
                            <option value="">Select format</option>
                            <option value="digital">Digital</option>
                            <option value="physical">Physical</option>
                        </select> */}
                </div>
                <div className="d-flex aic">
                    <span className="modify-info">Cultural area</span>
                    <p className="input-main" onClick={() => setOpenEditInput("cultural-area")}>{capitalizeFirstLetter(creation?.tag)}</p>
                    {/* <select
                        name="tag"
                        value={creation?.tag}
                        onChange={handleChange}
                        className="input-main"
                    >
                        <option value="">What's your creation about?</option>
                        {tags.filter(tag => tag.is_primary).map(tag =>
                            <option key={tag.tag_id} value={tag.tag_name}>{capitalizeFirstLetter(tag.tag_name)}</option>
                        )}
                    </select>*/}
                </div>
                <div className="d-flex aic">
                    <span className="modify-info">Title</span>
                    <p className="input-main text" onClick={() => setOpenEditInput("title")}>{creation?.title}</p>
                    {/* <input className="input-main" name="title" value={creation?.title} onChange={handleChange} /> */}
                </div>

                <div className="d-flex aic">
                    <span className="modify-info">Hashtags</span>
                    <p className="input-main fg-tag-blue" onClick={() => setOpenEditInput("hashtags")}>
                        {creation?.formattedTags.map(tag => `#${capitalizeFirstLetter(tag)}`).join(" ")}
                    </p>
                    {/* <input className="input-main fg-tag-blue" name="formattedTags" value={creation?.formattedTags} onChange={handleChange} /> */}

                </div>
                <div className="d-flex aic">
                    <span className="modify-info">About</span>
                    <p className={`input-main text ${!creation?.description?.length ? 'fg-grey' : ''}`} onClick={() => setOpenEditInput("description")}>
                        {creation?.description?.length > 0
                            ? (hasHtmlContent(creation?.description) ?
                                getFirstParagraphText(creation?.description) || getFirstTitleFromHtml(creation?.description) :
                                creation?.description
                            ) : 'Add more about the creation'}
                    </p>
                    {/* <input className="input-main" name="description" value={creation?.description} onChange={handleChange} /> */}
                </div>

                <div className="d-flex aic">
                    <span className="modify-info">Price</span>
                    <p className="input-main" onClick={() => setOpenEditInput("price")}>{creation?.price ? `€ ${creation?.price}` : 'Free'}</p>
                    {/* <input className="input-main" name="price" type="number" value={creation?.price} onChange={handleChange} /> */}
                </div>
                {/* <div className="d-flex aic">
                        <span className="modify-info">Availability</span>
                        <p className="input-main">{capitalizeFirstLetter(creation?.edition_type)}</p>

                        <select name="availability" value={creation?.edition_type} onChange={handleChange} className="input-main">
                            <option value="limited">Limited Edition</option>
                            <option value="unlimited">Unlimited Edition</option>
                            <option value="free">Unique Edition</option>
                        </select>
                    </div> */}
                <div className="d-flex aic">
                    <span className="modify-info">Quantity</span>
                    <p className="input-main" onClick={() => setOpenEditInput("availability")}>{creation?.edition_type === 'limited' ? creation?.media?.max_stock : creation?.edition_type === 'unique' ? "Unique" : 'Unlimited'}</p>
                    {/* <input className="input-main" name="max_stock" type="number" value={creation?.max_stock} onChange={handleChange} /> */}
                </div>
                <div className="d-flex aic">
                    <span className="modify-info">Credits</span>
                    <p className="input-main-credits" onClick={() => setOpenEditInput("credits")}>{creation?.credits}</p>
                    {/* <input className="input-main" name="max_stock" type="number" value={creation?.max_stock} onChange={handleChange} /> */}
                </div>
                
                {/* Download Toggle - Only for digital creations with files */}
                {!isPhysical && creation?.media?.media_url && (
                    <div className="d-flex aic jcsb">
                        <span className="modify-info">Allow Download</span>
                        <Toggle enabled={allowDownload} setEnabled={setAllowDownload} />
                    </div>
                )}
                
                {/* Physical Creation Fields */}
                {isPhysical && (
                    <>
                        {/* Shipping Method Field */}
                        <div className="d-flex aic">
                            <span className="modify-info">Shipping Method</span>
                            <p 
                                className="input-main" 
                                onClick={onOpenShippingMethodSelector}
                                style={{ cursor: 'pointer' }}
                            >
                                {selectedShippingMethodName || 'Select shipping method'}
                            </p>
                        </div>
                        
                        {/* Size & Quantity Field (for clothing category) */}
                        {creation?.category === 'clothing' && (
                            <div className="d-flex aic">
                                <span className="modify-info">Sizing & Quantities</span>
                                <p 
                                    className="input-main" 
                                    onClick={() => setOpenEditInput("sizes")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {isSizingAndQuantitiesEnabled && sizeEntries.length > 0
                                        ? `${sizeEntries.filter(e => e.size_label && e.size_label.trim()).length} size${sizeEntries.filter(e => e.size_label && e.size_label.trim()).length !== 1 ? 's' : ''}`
                                        : 'No sizes configured'}
                                </p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    </div> : <ModifyEditScreenSkeleton />)
}

export default MainEdit;